import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { PqrReceptionChannelFilters } from './filters';
import { PqrReceptionChannelList } from './list';
import {
    PQR_RECEPTION_CHANNEL,
    PQR_RECEPTION_CHANNEL_NEW,
} from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const PqrReceptionChannel = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de canal de recepción PQR"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_RECEPTION_CHANNEL_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_RECEPTION_CHANNEL,
                        }}
                    />
                }
            >
                <PqrReceptionChannelFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <PqrReceptionChannelList filters={filters} />
        </>
    );
};
